// 仕様: 認証フォーム状態管理用のRedux Slice
// ログインフォームの入力値とメッセージを管理
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface AuthFormState {
  userid: string;
  password: string;
  authFlg: boolean;
  loginMessage: string;
}

const initialState: AuthFormState = {
  userid: '',
  password: '',
  authFlg: true,
  loginMessage: '',
};

export const authFormSlice = createSlice({
  name: 'authForm',
  initialState,
  reducers: {
    // ユーザーID設定
    setUserid: (state, action: PayloadAction<string>) => {
      state.userid = action.payload;
    },
    // パスワード設定
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    // 認証フラグ設定
    setAuthFlg: (state, action: PayloadAction<boolean>) => {
      state.authFlg = action.payload;
    },
    // ログインメッセージ設定
    setLoginMessage: (state, action: PayloadAction<string>) => {
      state.loginMessage = action.payload;
    },
    // フォームリセット
    resetAuthForm: (state) => {
      return initialState;
    },
  },
});

export const {
  setUserid,
  setPassword,
  setAuthFlg,
  setLoginMessage,
  resetAuthForm,
} = authFormSlice.actions;

// セレクター
export const selectUserid = (state: RootState) => state.authForm.userid;
export const selectPassword = (state: RootState) => state.authForm.password;
export const selectAuthFlg = (state: RootState) => state.authForm.authFlg;
export const selectLoginMessage = (state: RootState) => state.authForm.loginMessage;

export default authFormSlice.reducer;
